export default "__VITE_ASSET__C6jG0NtJ__"